import { HttpClient } from '@opallabs/api'
import reducePostPlacement from '../reducePostPlacement'

const deletePostPlacement = ({ content_id }) =>
  HttpClient().delete(`/content/v2/${content_id}/placements`)

const destroyPostPlacement = (options) => (dispatch) =>
  deletePostPlacement(options)
    .then((response) => {
      if (response.status === 204) {
        const { content_id, placement_id } = options

        dispatch(
          reducePostPlacement({
            content_id,
            placement_id,
          })
        )

        return {}
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destroyPostPlacement
